import { createContext } from 'react';

export const CompetitionRegisterContext = createContext({
  competitions: [],
  competition: {},
  competitionRegister: {},
  users: [],
  user: {},
  teams: [],
  team: {},
  leagues: [],
  league: {},
  coaches: [],
  coach: {},
  province_id: null,
  supervisors: [],
  supervisor: {},
  errors: {
    single: {},
    team: {},
    league: {},
  },
  checkRegister: false,
});
